$(document).ready(function() {
  
  $('.banner-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 2000,
  });
  
  $('.featured_slider .grid-product.hide').remove();
  
  $('.featured_slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    autoplaySpeed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

   $('.client_logo_slider').slick({
    dots: false,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true, 
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });

   $('.review_home_slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        speed: 400,
        autoplay: false,
        autoplaySpeed: 1500,
        responsive: [
          {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        ]
    });


    if ($(window).width() < 575) {

     $(".insta_section").slick({
      autoplay: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      speed: 3000,
      arrows: false,
      dots: false,
      cssEase: 'linear',
      autoplaySpeed: 0,
      focusOnSelect: false
      });
      
    }

   setTimeout(function() {
     if($('.recent_slider .new-grid .grid-item').length > 4){
     $('.recent_slider .new-grid').slick({
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      arrows: true,
      dots: false,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    }
  }, 3500);
  
  //setTimeout(function() {        
     $('.more-products-collection .new-grid').slick({
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      arrows: true,
      dots: false,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
 // }, 3000);
  
  // setTimeout(function() {        
    //  $('.more-products-vendors .new-grid').slick({
    //   infinite: false,
    //   speed: 300,
    //   slidesToShow: 4,
    //   arrows: true,
    //   dots: false,
    //   slidesToScroll: 4,
    //   responsive: [
    //     {
    //       breakpoint: 1199,
    //       settings: {
    //         slidesToShow: 3,
    //         slidesToScroll: 3
    //       }
    //     },
    //     {
    //       breakpoint: 767,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 2
    //       }
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1
    //       }
    //     }
    //   ]
    // });
 // }, 3000);   

// Hidding "OFFERTE AANVRAGEN" button on .de store
  if (window.location.href.indexOf('https://crazylabels.de/') !== -1) {
    var $requestButton = $('#request-button');
    var $requestButtonBefore = $('.site-header__element--sub');
    setTimeout(function() {
      var $klaviyoHide = $('button.needsclick.kl-teaser-RcTWZy');
      $klaviyoHide.hide();
    }, 1500);
  
    if ($requestButton.length) {
      $requestButton.hide();
      $('head').append('<style>.site-header__element--sub::before { background: transparent !important; content: none !important; }</style>');
    }
  }
// Hidding "OFFERTE AANVRAGEN" button on .de store

  
});


 document.addEventListener( 'DOMContentLoaded', function () {    
    $('.description_tab ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  }, false );





